import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";

interface MessagingBroadcastSendProps {
    sending: boolean;
    broadcasting: boolean;
    disableSend: boolean;
    send: (immediate: boolean) => void;
}

class MessagingBroadcastSend extends React.Component<MessagingBroadcastSendProps> {
    render(): React.ReactNode {
        return (
            this.props.broadcasting && (
                <div className="col-pane broadcast-send">
                    <button
                        className="theme-button message-send-button right"
                        disabled={
                            this.props.disableSend && !this.props.broadcasting
                        }
                        onClick={() => this.props.send(true)}>
                        {!this.props.sending && <i className="fill">send</i>}
                        {this.props.sending && <i className="spin">sync</i>}
                        <span>Send</span>
                    </button>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MessagingBroadcastSend);
